export enum LocalStorageItem
{
  RECENT_CHATS  = 'RecentChats',
  DRIVER = 'Driver',
  OPERATORS_RECENT_CHATS = 'OPERATORS_RECENT_CHATS'
}
